import { Components, Theme } from '@mui/material/styles'
import { MuiButtonOverrides } from './button'
import { 
  MuiCardOverrides, 
  MuiCardContentOverrides, 
  MuiCardActionsOverrides 
} from './card'
import { MuiTextFieldOverrides } from './textField'
import { MuiChipOverrides } from './chip'
import { MuiPaperOverrides } from './paper'
import { MuiAlertOverrides } from './alert'
import { MuiContainerOverrides } from './container'
import { MuiGridOverrides } from './grid'

export const componentOverrides: Components<Theme> = {
  MuiButton: MuiButtonOverrides,
  MuiCard: MuiCardOverrides,
  MuiCardContent: MuiCardContentOverrides,
  MuiCardActions: MuiCardActionsOverrides,
  MuiTextField: MuiTextFieldOverrides,
  MuiChip: MuiChipOverrides,
  MuiPaper: MuiPaperOverrides,
  MuiAlert: MuiAlertOverrides,
  MuiContainer: MuiContainerOverrides,
  MuiGrid: MuiGridOverrides,
}
